<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import Drawer from "vue-simple-drawer";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AddEdit from "./AddEdit.vue";
import ORenkAciklamalari from "@/models/ORenkAciklamalari";
export default {
  mixins: [Api, Sabit, ORenkAciklamalari],
  page: {
    title: "Renk Açıklamaları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Drawer,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("ORenkAciklamalari.Title"),
      items: [
        {
          text: this.$t("ORenkAciklamalari.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("ORenkAciklamalari.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("ORenkAciklamalari.Title"),
          active: true,
        },
      ],
      FilitrelemePenceresi: false,
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      siralama:"&Asc=Renk",
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
    };
  },

  methods: {
    Get() {
       let Filter = "";

      if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }

      this.ActionsFilterGet({ Service: "ORenkAciklamalari", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
  filters: {},
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4"></div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.ORenkAciklamalari @click="(DataUpdate = ORenkAciklamalariData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i> {{ $t("ORenkAciklamalari.Page.YeniKayitEkle") }}</button>
                  </div>
                </div>
              </div>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("ORenkAciklamalari.Table.Renk") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=Renk'" @click="siralama='&Asc=Renk', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Renk'" @click="siralama='&Desc=Renk', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   </th>
                      <th>{{ $t("ORenkAciklamalari.Table.Aciklama") }}
                      <i style="margin-left:10px" v-if="siralama!='&Asc=Aciklama'" @click="siralama='&Asc=Aciklama', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Aciklama'" @click="siralama='&Desc=Aciklama', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   </th>
                      <th style="width: 85px; text-align: center; vertical-align: middle;">{{ $t("ORenkAciklamalari.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Renk }}</th>
                      <td>{{ Data.Aciklama }}</td>
                      <td style="width: 85px; text-align: center; vertical-align: middle;">
                        <b-button-group>
                          <b-button variant="success" v-b-modal.ORenkAciklamalari @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="fas fa-pencil-alt"></i></b-button>
                          <b-button variant="danger" @click="Delete('ORenkAciklamalari', Data.Id)"><i class="fas fa-trash-alt"></i></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              Filitreleme
            </h5>
          </div>
          <div class="offcanvas-body">
            Aşağıda Bulunan Kriterlere Göre Filitreleme Yapabilirsiniz.
            <hr />
            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">Açıklama</label>
              <b-form-input for="text" value=""></b-form-input>
            </div>
            <b-button @click="Get" class="btn btn-primary" variant="primary">Filtrele</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
